import { Box, Typography } from "@material-ui/core";
import { People } from "@material-ui/icons";
import { Button } from "@bonliva-crm/ui";
import { useGlobalUserSelector } from "@containers/user-selector-modal";
import { useLocale } from "@hooks";

type Props = {
  onUserChange: (userId: string) => void;
};

export function ConsultantPipelineNotFound(props: Props) {
  const { select } = useGlobalUserSelector();
  const { locale } = useLocale();

  const handleSelectUser = () => {
    select({ multi: false }).then((selected) => {
      if (selected.length > 0) {
        props.onUserChange(selected[0]._id);
      }
    });
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" pt="20rem">
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="body1" style={{ fontSize: "1.5rem" }}>
          {locale.pipeline.noBoardFound}
        </Typography>

        <Box mt="5rem">
          <Button startIcon={<People />} variant="outlined" onClick={handleSelectUser}>
            {locale.pipeline.switchBoard}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
